import { oz } from '@weft/utils';

export const HUBSPOT_CREATE_TOKEN_ACTIONS = Object.freeze({
  refreshToken: 'refresh_token',
  authCode: 'authorization_code',
});

export const hubspotCreateTokenActionsSchema = oz.nativeEnum(HUBSPOT_CREATE_TOKEN_ACTIONS);

export type HubspotCreateTokenActions = oz.infer<typeof hubspotCreateTokenActionsSchema>;